import { render, staticRenderFns } from "./Visualizzatore.vue?vue&type=template&id=d1b2ccf6&scoped=true&"
import script from "./Visualizzatore.vue?vue&type=script&lang=js&"
export * from "./Visualizzatore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b2ccf6",
  null
  
)

export default component.exports